import type { KitSaveAttempt } from "~fulfill/product/kits/helpers/kitSaveAttempt";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type KitWizardMode = "closed" | "create" | "edit";

export interface KitsState {
	pendingSaveAttempts: Record<string, KitSaveAttempt>;
	selectedKitId: string | null;
	wizardKitId: string | null;
	wizardMode: KitWizardMode;
}

const initialState: KitsState = {
	pendingSaveAttempts: {},
	selectedKitId: null,
	wizardKitId: null,
	wizardMode: "closed"
};

const kitsSlice = createSlice({
	initialState,
	name: "kits",
	reducers: {
		closeKitWizard: (state) => {
			state.wizardKitId = null;
			state.wizardMode = "closed";
		},
		openKitWizard: (state, action: PayloadAction<Exclude<KitWizardMode, "closed">>) => {
			state.wizardKitId = action.payload === "edit" ? state.selectedKitId : null;
			state.wizardMode = action.payload;
		},
		removeKitSaveAttempt: (state, action: PayloadAction<string>) => {
			delete state.pendingSaveAttempts[action.payload];
		},
		setSelectedKit: (state, action: PayloadAction<string | null>) => {
			state.selectedKitId = action.payload;
		},
		upsertKitSaveAttempt: (state, action: PayloadAction<{ key: string; attempt: KitSaveAttempt }>) => {
			state.pendingSaveAttempts[action.payload.key] = action.payload.attempt;
		}
	}
});

export const { closeKitWizard, openKitWizard, removeKitSaveAttempt, setSelectedKit, upsertKitSaveAttempt } =
	kitsSlice.actions;

export default kitsSlice.reducer;
